import React from 'react'
import EmptyIcon from "../../Images/EmptyIcon.svg"

export default function Empty() {
  return (
    <div><img src={EmptyIcon}/></div>
  )
}
